import en from './en';
import hr from './hr';

export const resources = {
    en,
    hr
};
